import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

export class ExpandableController extends Controller<HTMLButtonElement> {
    private readonly ID_ATTRIBUTE = 'aria-controls';
    private readonly CONTROLLED_ATTRIBUTE = 'data-controlled-attr';

    id: string;
    target: HTMLElement;
    attribute: string;

    static register(application: Application) {
        application.register('expandable', this);
    }

    connect() {
        this.id = this.element.attributes[this.ID_ATTRIBUTE].value;
        this.target = document.getElementById(this.id);

        const controlledAttr = JSON.parse(this.target.attributes[this.CONTROLLED_ATTRIBUTE].value);
        this.attribute = Object.keys(controlledAttr)[0];

        this.element.setAttribute(this.attribute, controlledAttr[this.attribute]);

        this.loadState();
    }

    loadState() {
        const prevState = sessionStorage.getItem(this.id);
        if (prevState === null) return;
        this.element.attributes[this.attribute].value = prevState;
    }

    saveState() {
        const isExpanded = this.element.attributes[this.attribute].value;
        sessionStorage.setItem(this.id, isExpanded);
    }

    toggle(event: Event) {
        switch (this.element.attributes[this.attribute].value) {
            case 'true':
                this.element.attributes[this.attribute].value = 'false';
                break;
            case 'false':
                this.element.attributes[this.attribute].value = 'true';
                break;
            default:
                return;
        }

        this.saveState();
    }
}